import { useEffect } from "react";
import { useRouteError, isRouteErrorResponse, Link } from "react-router-dom";
import { Sentry } from "../lib/sentry.ts";

export function ErrorPage() {
  const err = useRouteError();
  const msg = isRouteErrorResponse(err) ? err.statusText : String(err);

  // Report router-caught errors to GlitchTip. ErrorBoundary doesn't
  // catch these because React Router intercepts them first.
  useEffect(() => {
    if (err) Sentry.captureException(err);
  }, [err]);

  return (
    <main className="mx-auto max-w-md px-6 py-20 text-center">
      <h1 className="font-serif text-3xl">Something went wrong.</h1>
      <p className="mt-3 font-mono text-xs text-parchment/60">{msg}</p>
      <Link to="/" className="mt-6 inline-block stamp-badge">
        ← Back to dashboard
      </Link>
    </main>
  );
}
